import { NavLink } from "react-router-dom";
import { MapPin, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function TopBar() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div
      className="fixed top-2 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-40 flex justify-end gap-2 px-3 pointer-events-none"
      data-testid="top-bar"
    >
      <NavLink
        to="/app/map"
        data-testid="top-map-btn"
        className={({ isActive }) =>
          `h-10 w-10 rounded-full flex items-center justify-center pointer-events-auto backdrop-blur-md border transition-colors ${
            isActive
              ? "bg-[#3CFF7E] text-[#0A0A0A] border-[#3CFF7E]"
              : "bg-[#111827]/80 text-white border-white/15 hover:border-white/40"
          }`
        }
        aria-label="Map"
      >
        <MapPin size={18} strokeWidth={2.2} />
      </NavLink>
      <NavLink
        to="/app/profile"
        data-testid="top-profile-btn"
        className={({ isActive }) =>
          `h-10 w-10 rounded-full flex items-center justify-center pointer-events-auto backdrop-blur-md border transition-colors ${
            isActive
              ? "bg-[#3CFF7E] text-[#0A0A0A] border-[#3CFF7E]"
              : "bg-[#111827]/80 text-white border-white/15 hover:border-white/40"
          }`
        }
        aria-label="Profile"
      >
        <User size={18} strokeWidth={2.2} />
      </NavLink>
    </div>
  );
}
